// extracted by mini-css-extract-plugin
module.exports = {"root":"lower_root__Yw5Du"};